module.exports = __webpack_public_path__ + "static/Apercu-Light-a5883223b079634bdee750b8f594735a.woff2";